import { Component, Input, inject } from '@angular/core'
import { PulsarWebSocketService } from 'src/app/data/services/application/pulsar-websocket/pulsar-websocket.service'
import { BrandingVariant } from 'src/app/domain/enums/components/branding.enum'
import { DialogSize } from 'src/app/domain/enums/components/dialog.enum'

@Component({
  selector: 'app-offline-screen',
  templateUrl: './offline-screen.component.html',
  styleUrls: ['./offline-screen.component.scss']
})
export class OfflineScreenComponent {
  @Input() isShow: boolean = false

  private pulsarWebSocketService = inject(PulsarWebSocketService)

  connectionState$ = this.pulsarWebSocketService.connectionState$
  octavioSadVersionImage: string = `assets/images/octavio/sad-version-2.png`
  brandingVariant = BrandingVariant
  dialogSize = DialogSize
  showInfrastructureModal = false

  openInfrastructureModal(): void {
    this.showInfrastructureModal = true
  }

  closeInfrastructureModal(): void {
    this.showInfrastructureModal = false
  }
}
